export const serializeCommaSeparatedQueryParam = (values: readonly string[] | undefined): string | undefined =>
  values?.length ? values.join(',') : undefined;
